import styled from 'styled-components';
import { NavbarLayoutProps } from '../../styles/types';

export const NavbarContainerUI = styled.div`
  width: 100%;

  display: flex;
  align-items: center;

  height: 79px;

  background: #f5f5f5;
`;

export const TwoNavsContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 0 10px;
  flex-direction: column;

  gap: 0;
`;

export const NavbarLayout = styled.div<NavbarLayoutProps>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  width: auto;
  gap: 12px;
  height: 25px;

  .link {
    text-decoration: underline;
  }

  .text {
    background: none;
    border: 0;
  }

  .text,
  a {
    color: rgba(56, 72, 91, 0.8);
    font-size: 16px;
    margin: 0;
    font-weight: 400;
    line-height: 15px;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const LayoutsContainer = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;

  display: flex;
  align-items: center;

  justify-content: space-between;
`;
